import React from "react";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export default function StokistTable({ chartData, stokistData }) {
  const currentYear = new Date().getFullYear();
  const stockistNames = stokistData ? stokistData.map((s) => s.name) : [];

  const yearlyTotals = stockistNames.reduce((acc, name) => {
    acc[name] = 0;
    return acc;
  }, { monthlyTotal: 0 });

  chartData?.forEach((row) => {
    yearlyTotals.monthlyTotal += row.monthlyTotal || 0;
    stockistNames.forEach((name) => {
      yearlyTotals[name] += row[name] || 0;
    });
  });

  const fmt = (val) =>
    val ? val.toLocaleString("en-IN", { maximumFractionDigits: 0 }) : "0";

  return (
    <div className="w-full bg-[#c0f0e2] rounded-lg shadow-lg p-4 mt-20">
      <div className="bg-skin-button rounded-lg p-4 mb-6">
        <h3 className="text-2xl md:text-3xl font-bold text-gray-800">
          {currentYear} Stockist Overview
        </h3>
      </div>

      <div className="overflow-x-auto rounded-xl shadow-inner">
        <table className="w-full text-sm text-gray-800 border-collapse">
          <thead>
            <tr className="bg-skin-button text-gray-800">
              <th className="sticky left-0 z-20 bg-skin-button px-4 py-3 text-left font-semibold border border-teal-200 min-w-[140px]">
                Stockist
              </th>
              {chartData?.map((_, idx) => (
                <th
                  key={idx}
                  className="px-4 py-3 text-right font-semibold border border-teal-200 min-w-[90px]"
                >
                  {MONTHS[idx]}
                </th>
              ))}
              <th className="px-4 py-3 text-right font-semibold border border-teal-200 min-w-[110px] bg-teal-200">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {stockistNames.map((name, idx) => (
              <tr
                key={name}
                className={idx % 2 === 0 ? "bg-white/60" : "bg-white/30"}
              >
                <td className="sticky left-0 z-10 bg-white px-4 py-2 font-medium border border-teal-100">
                  {name}
                </td>
                {chartData?.map((row, mIdx) => (
                  <td
                    key={mIdx}
                    className="px-4 py-2 text-right border border-teal-100"
                  >
                    {fmt(row[name])}
                  </td>
                ))}
                <td className="px-4 py-2 text-right font-semibold border border-teal-100 bg-teal-50">
                  {fmt(yearlyTotals[name])}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-teal-200 font-bold">
              <td className="sticky left-0 z-10 bg-teal-200 px-4 py-3 border border-teal-300">Monthly Total</td>
              {chartData?.map((row, idx) => (
                <td key={idx} className="px-4 py-3 text-right border border-teal-300">
                  {fmt(row.monthlyTotal)}
                </td>
              ))}
              <td className="px-4 py-3 text-right border border-teal-300 bg-teal-300">
                {fmt(yearlyTotals.monthlyTotal)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
